"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.primaryButtons = void 0;
var material_1 = require("@mui/material");
exports.primaryButtons = [
    {
        props: { variant: 'primaryDefault' },
        style: function (_a) {
            var theme = _a.theme;
            return ({
                color: theme.palette.text.light,
                backgroundColor: theme.palette.secondary.main,
                '&:hover': {
                    backgroundColor: theme.palette.secondary.dark,
                },
                '&:focus': {
                    backgroundColor: theme.palette.secondary.dark,
                },
                '&:active': {
                    color: theme.palette.secondary.darkest,
                    backgroundColor: theme.palette.secondary.light,
                },
                '&:disabled': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.neutral, 0.3),
                    color: theme.palette.text.disabled,
                },
            });
        },
    },
    {
        props: { variant: 'primaryHC' },
        style: function (_a) {
            var theme = _a.theme;
            return ({
                color: theme.palette.secondary.main,
                backgroundColor: theme.palette.neutrals.white,
                '&:hover': {
                    backgroundColor: theme.palette.secondary.light,
                },
                '&:focus': {
                    backgroundColor: theme.palette.secondary.light,
                },
                '&:active': {
                    color: theme.palette.secondary.darkest,
                    backgroundColor: theme.palette.secondary.lightest,
                },
                '&:disabled': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.neutral, 0.3),
                    color: theme.palette.text.disabled,
                },
            });
        },
    },
    {
        props: { variant: 'primaryAccent1' },
        style: function (_a) {
            var theme = _a.theme;
            return ({
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.accent01.main,
                '&:hover': {
                    backgroundColor: theme.palette.accent01.dark,
                },
                '&:focus': {
                    backgroundColor: theme.palette.accent01.dark,
                },
                '&:active': {
                    backgroundColor: theme.palette.accent01.light,
                },
                '&:disabled': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.neutral, 0.3),
                    color: theme.palette.text.disabled,
                },
            });
        },
    },
];
